/**
 * Performance Settings Component — OTD configuration only.
 */
import { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Loader2, Save, BookOpen } from 'lucide-react';
import {
  OTDSettingsTab,
  PerformanceGuideTab,
  usePerformanceSettings,
} from './performance';

export default function PerformanceSettings() {
  const [activeTab, setActiveTab] = useState('otd');

  const {
    loading,
    saving,
    hasChanges,
    formData,
    handleInputChange,
    handleSave,
  } = usePerformanceSettings();

  if (loading) {
    return (
      <Card>
        <CardContent className="flex items-center justify-center py-8">
          <Loader2 className="h-8 w-8 animate-spin" />
          <span className="ml-2">Loading performance settings...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold">Customer Performance Settings</h2>
          <p className="text-sm text-muted-foreground">
            Configure On-Time Delivery (OTD) range thresholds for customer card colours and quick filters.
          </p>
        </div>
        <Button onClick={handleSave} disabled={!hasChanges || saving}>
          {saving ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="h-4 w-4 mr-2" />
              Save Changes
            </>
          )}
        </Button>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="otd">OTD Settings</TabsTrigger>
          <TabsTrigger value="guide" className="flex items-center gap-1">
            <BookOpen className="h-4 w-4" />
            Guide
          </TabsTrigger>
        </TabsList>

        <TabsContent value="otd">
          <OTDSettingsTab formData={formData} onInputChange={handleInputChange} />
        </TabsContent>

        <TabsContent value="guide">
          <PerformanceGuideTab formData={formData} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
